import React, { Component } from "react"; 
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../components/CustomComponent.js";
import { report_car_receipt } from "../components/Report.js";
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      document_no: "",
      created_at: "",
      customer_name: "",
      customer_phone: "",
      type: "",
      brand: "",
      model: "",
      car_registration: "",
      cause: "",

      user: "",
      user_type: ""
    };
  }

  async componentDidMount() {
    loading(false);
        if(params("uid")){
          await this.Get(params("uid"));
          }
    // window.print();
  }
  Get = async (uid) => {
      loading(true);
      let result = await GET("admin/repairs/list", { uid });
      if (result?.status) {
      const item = result.data;
      const data = {
          document_no: item.document_no,
          created_at: item.created_at,
          customer_name: item.customer?.full_name || "",
          customer_phone: item.customer?.phone || "",
          brand: item.brand || "",
          car_registration: item.car_registration || "",
          user: item.user?.full_name || "",
          user_type: item.user?.user_type || "",
          type: item.type || "",
          model: item.model || "",
          cause: item.cause || ""
      }
      this.setState(data);
      await report_car_receipt(data);
    //   setTimeout(() => {
        
    // window.close();
    //   }, 200);
      }
  
      loading(false);
    };
  render() {
    const {document_no,
created_at,
customer_name,
customer_phone,
brand,
car_registration,user,
user_type,type, model, cause} = this.state;
    return (
      <div className="mx-auto bg-white p-5 pdf" style={{ width: 446 }}>
        <h5 className="fw-bold text-center mb-3">ใบรับงาน</h5>
        <h5 className="fw-bold text-center mb-3">ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000)</h5>
        <div className="fw-bold text-center mb-3">61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่</div>
        <div className="fw-bold text-center mb-3">โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060</div>
        
        <div className="row pt-3">
          <div className="col-12 mb-1">
            <div className="fw-bold mb-4">วันที่ : {format_date(created_at,"dd mmmm yyyy", "th")}</div>
          </div>
          <div className="col-12 mb-1 position-relative">
            <div className="mb-4"><b>เลขที่เอกสาร</b>...............................................................................</div>
          <div className="position-absolute" style={{top: -4,left: 90}}>{document_no}</div>
          </div>
          <div className="col-12 mb-1 position-relative">
            <div className="mb-4"><b>ชื่อลูกค้า</b>.....................................................................................</div>
          <div className="position-absolute" style={{top: -4,left: 90}}>{customer_name}</div>
          </div>
          <div className="col-12 mb-1 position-relative">
            <div className="mb-4"><b>เบอร์โทร</b>.....................................................................................</div>
          <div className="position-absolute" style={{top: -4,left: 90}}>{customer_phone}</div>
          </div>
          <div className="col-12 mb-1 position-relative">
            <div className="mb-4"><b>ประเภท</b>.......................................................................................</div>
            <div className="position-absolute" style={{top: -4,left: 90}}>{type}</div>
          </div>
          <div className="col-12 mb-1 position-relative">
            <div className="mb-4"><b>ยี่ห้อ</b>............................................................................................</div>
          <div className="position-absolute" style={{top: -4,left: 60}}>{brand}</div>
          </div>
          <div className="col-12 mb-1 position-relative">
            <div className="mb-4"><b>ทะเบียน</b>......................................................................................</div>
          <div className="position-absolute" style={{top: -4,left: 90}}>{car_registration} {model}</div>
          </div>
          <div className="col-12 mb-1 position-relative">
            <div className="mb-4"><b>บันทึกช่าง</b>...................................................................................</div>
            <div className="mb-4">...................................................................................................</div>
            <div className="mb-4">...................................................................................................</div>
            <div className="mb-4">...................................................................................................</div>
            <div className="mb-4">...................................................................................................</div>
            <div className="mb-4">...................................................................................................</div>
            <div className="mb-4">...................................................................................................</div>
          <div className="position-absolute" style={{top: -15,textIndent: 80,lineHeight:3}}>{cause}</div>
          </div>
          <div className="col-12 mb-2">
            <div className="fw-bold mb-4">ผู้รับงาน : {user}</div>
            <div className="fw-bold mb-4">แผนก : {user_type === "technical" ? "ช่าง": "-"}</div>
          </div>
        </div>
      </div>
    );
  }
}
